import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'rzf-card',
  styleUrl: 'rzf-card.css',
  shadow: true,
})
export class RzfCard {
  @Prop() link: string;

  render() {
    return (
      <article class="rzf-card">
        {this.link && <a href={this.link} target="_blank" rel="noopener noreferrer"></a>}
        <slot name="image"></slot>
        <section class="rzf-card__content">
          <header class="rzf-card__header">
            <slot name="title"></slot>
            <slot name="subtitle"></slot>
          </header>
          <slot name="description"></slot>
        </section>
        <footer class="rzf-card__footer">
          <slot name="footer"></slot>
        </footer>
      </article>
    );
  }
}
